import type { InfinityId } from "@gooner/shared";
import { INFINITY_DEFS } from "@gooner/shared";
import { IconSparkle } from "../control/ui/icons";
import { cx } from "../control/ui/primitives";

/**
 * A scroll's mark, the WallGlyph pattern: Random wears its die, Enhanced wears the REAL
 * sparkle — the four-point mark that already means "GoonerAI did this" on every keyword
 * the vision model assigned (TagBubble) — and Colorwave wears a colour wheel, the one
 * picture of "a different colour every page" that an emoji rainbow only gestures at.
 * `InfinityDef.icon` stays a string for the places that can only carry text (the stub
 * view's icon, the Now Showing pill); this is what a React row renders.
 *
 * Decorative: the scroll's NAME sits beside it wherever this appears. `aria-hidden`,
 * the same as the emoji span it replaces.
 */
export function InfinityGlyph({ infinityId, className }: { infinityId: InfinityId; className?: string }) {
  const def = INFINITY_DEFS[infinityId];
  return (
    <span aria-hidden className={cx("inline-flex items-center justify-center", className)}>
      {def.feed === "roulette" ? (
        <IconSparkle width={16} height={16} className="text-[var(--color-accent)]" />
      ) : def.feed === "colorwave" ? (
        <span
          className="block h-4 w-4 rounded-full"
          style={{
            background:
              "conic-gradient(#f43f5e, #f59e0b, #facc15, #22c55e, #06b6d4, #6366f1, #d946ef, #f43f5e)",
          }}
        />
      ) : (
        def.icon
      )}
    </span>
  );
}
